const partnerLogos = [
  // { id: 1, src: "/websiteAssets/1.png", alt: "Partner Logo 1" },
  { id: 2, src: "/websiteAssets/2.jpeg", alt: "Partner Logo 2" },
  {
    id: 3,
    src: "/websiteAssets/3.png",
    alt: "Partner Logo 3",
  },
  {
    id: 4,
    src: "/websiteAssets/4.png",
    alt: "Partner Logo 4",
  },
  {
    id: 5,
    src: "/websiteAssets/5.png",
    alt: "Partner Logo 5",
  },
  {
    id: 6,
    src: "/websiteAssets/6.png",
    alt: "Partner Logo 6",
  },
  {
    id: 7,
    src: "/websiteAssets/7.png",
    alt: "Partner Logo 7",
  },
  {
    id: 8,
    src: "/websiteAssets/8.png",
    alt: "Partner Logo 8",
  },
  {
    id: 9,
    src: "/websiteAssets/9.png",
    alt: "Partner Logo 9",
  },
  {
    id: 10,
    src: "/websiteAssets/10.png",
    alt: "Partner Logo 10",
  },
  {
    id: 11,
    src: "/websiteAssets/11.png",
    alt: "Partner Logo 11",
  },
  {
    id: 12,
    src: "/websiteAssets/12.png",
    alt: "Partner Logo 12",
  },
  {
    id: 13,
    src: "/websiteAssets/13.png",
    alt: "Partner Logo 13",
  },
  {
    id: 14,
    src: "/websiteAssets/14.png",
    alt: "Partner Logo 14",
  },
  {
    id: 15,
    src: "/websiteAssets/15.png",
    alt: "Partner Logo 15",
  },
  {
    id: 16,
    src: "/websiteAssets/16.png",
    alt: "Partner Logo 16",
  },
  {
    id: 17,
    src: "/websiteAssets/17.png",
    alt: "Partner Logo 17",
  },
  {
    id: 18,
    src: "/websiteAssets/18-1.png",
    alt: "Partner Logo 18",
  },
  {
    id: 19,
    src: "/websiteAssets/19-2.png",
    alt: "Partner Logo 19",
  },
  {
    id: 20,
    src: "/websiteAssets/20.jpeg",
    alt: "Partner Logo 20",
  },
  {
    id: 21,
    src: "/websiteAssets/21.png",
    alt: "Partner Logo 21",
  },
  {
    id: 22,
    src: "/websiteAssets/22.png",
    alt: "Partner Logo 22",
  },
  {
    id: 23,
    src: "/websiteAssets/23.png",
    alt: "Partner Logo 23",
  },
  {
    id: 24,
    src: "/websiteAssets/24.png",
    alt: "Partner Logo 24",
  },
  {
    id: 25,
    src: "/websiteAssets/25.png",
    alt: "Partner Logo 25",
  },
  {
    id: 26,
    src: "/websiteAssets/26.png",
    alt: "Partner Logo 26",
  },
  {
    id: 27,
    src: "/websiteAssets/27.png",
    alt: "Partner Logo 27",
  },
  {
    id: 28,
    src: "/websiteAssets/28.png",
    alt: "Partner Logo 28",
  },
  {
    id: 29,
    src: "/websiteAssets/29.png",
    alt: "Partner Logo 29",
  },
  {
    id: 30,
    src: "/websiteAssets/30.png",
    alt: "Partner Logo 30",
  },
  {
    id: 31,
    src: "/websiteAssets/31.png",
    alt: "Partner Logo 31",
  },
  {
    id: 32,
    src: "/websiteAssets/32.png",
    alt: "Partner Logo 32",
  },
  {
    id: 33,
    src: "/websiteAssets/33.png",
    alt: "Partner Logo 33",
  },
  {
    id: 34,
    src: "/websiteAssets/34.png",
    alt: "Partner Logo 34",
  },
  // {
  //   id: 35,
  //   src: "/websiteAssets/35.png",
  //   alt: "Partner Logo 35",
  // },
  {
    id: 36,
    src: "/websiteAssets/36.png",
    alt: "Partner Logo 36",
  },
  {
    id: 37,
    src: "/websiteAssets/37.png",
    alt: "Partner Logo 37",
  },
  {
    id: 38,
    src: "/websiteAssets/38.png",
    alt: "Partner Logo 38",
  },
  {
    id: 39,
    src: "/websiteAssets/39.png",
    alt: "Partner Logo 39",
  },
  {
    id: 40,
    src: "/websiteAssets/40.png",
    alt: "Partner Logo 40",
  },
  {
    id: 41,
    src: "/websiteAssets/41.png",
    alt: "Partner Logo 41",
  },
  {
    id: 42,
    src: "/websiteAssets/42.png",
    alt: "Partner Logo 42",
  },
  //Already Added
  // {
  //   id: 43,
  //   src: "/websiteAssets/43.png",
  //   alt: "Partner Logo 43",
  // },
  {
    id: 44,
    src: "/websiteAssets/44.png",
    alt: "Partner Logo 44",
  },
  {
    id: 45,
    src: "/websiteAssets/45.png",
    alt: "Partner Logo 45",
  },
  {
    id: 46,
    src: "/websiteAssets/46.png",
    alt: "Partner Logo 46",
  },
  {
    id: 47,
    src: "/websiteAssets/47.jpeg",
    alt: "Partner Logo 47",
  },
  {
    id: 48,
    src: "/websiteAssets/48.jpeg",
    alt: "Partner Logo 48",
  },
  {
    id: 49,
    src: "/websiteAssets/49.png",
    alt: "Partner Logo 49",
  },
  {
    id: 50,
    src: "/websiteAssets/50.png",
    alt: "Partner Logo 50",
  },
  {
    id: 51,
    src: "/websiteAssets/51.png",
    alt: "Partner Logo 51",
  },
  {
    id: 52,
    src: "/websiteAssets/52.jpeg",
    alt: "Partner Logo 52",
  },
  {
    id: 53,
    src: "/websiteAssets/53.jpeg",
    alt: "Partner Logo 53",
  },
  {
    id: 54,
    src: "/websiteAssets/54.jpeg",
    alt: "Partner Logo 54",
  },
];

export default partnerLogos;
